﻿import {translation} from "@2d-front-monorepo/core";
import {
	AttachmentsComponent,
	formatDate, formatTime,
	IntegraZone,
	PermitResult
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../../api-endpoint";
import {PermitsState} from "../../../contexts/PermitsContext";

const filesPrefix = API_ENDPOINT.fileDownload;

export function HolderComponent({permit, permits, zone}: { permit: PermitResult, permits: PermitsState, zone?: IntegraZone }): JSX.Element {
	const zoneName = zone == null ? "" : zone.name || zone.id;

	return <div className="card">
		<div className="grid padded">
			<dl className="permit__date col-1of4">
				<dt>{translation(PermitTranslations.start_date)}</dt>
				<dd>
					<span>{formatDate(permit.startDate.toDateOnly())}</span>
					<span>{formatTime(permit.startDate.toTimeOnly())}</span>
				</dd>
			</dl>
			<dl className="permit__date col-1of4">
				<dt>{translation(PermitTranslations.end_date)}</dt>
				<dd>
					<span>{permit.endDate && formatDate(permit.endDate.toDateOnly())}</span>
					<span>{permit.endDate && formatTime(permit.endDate.toTimeOnly())}</span>
				</dd>
			</dl>

			{zone && <dl className="title-desc col-1of4">
                <dt>{translation(PermitTranslations.zone)}</dt>
                <dd>{zoneName}</dd>
            </dl>}

			<dl className="title-desc col-1of4">
				<dt>{translation(PermitTranslations.email)}</dt>
				<dd>{permits.holder.email}</dd>
			</dl>

			<AttachmentsComponent entity={permit} linkPrefix={filesPrefix} className="col-1of4"/>
		</div>
	</div>
}
